import Vue from 'vue';
import axios from 'axios';
import {getNotificationsApiUrl, getConfig} from '@/utils/config';

/* eslint no-console: "off" */

export default {
  fetchNotifications() {
    const url = `${getNotificationsApiUrl()}/notifications/draft/status`;
    return axios.get(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs": "true"
        }),
      }
    })
    .then((response) => {
      Vue.$log.debug('received notifications from server', response.data);
      return response.data;
    })
      .catch(err => {
        throw err;
      });
  },

  fetchNotification(id) {
    const url = `${getNotificationsApiUrl()}/notifications/draft/status/${id}`;
    return axios.get(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs": "true"
        }),
      }
    })
    .then((response) => {
      Vue.$log.debug('received notification from server', response.data);
      return response.data;
    })
      .catch(err => {
        throw err;
      });
  },

  createNotification(notification) {
    const url = `${getNotificationsApiUrl()}/notifications/draft/create`;
    return axios.post(url,
      notification, {
        headers: {
          ...Vue.prototype.$OAuth.buildHttpHeader({
            'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
            'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
            Accept: "application/json",
            "Content-Type": "application/json; charset=UTF-8",
            "adfs": "true"
          }),
        }
      }
    )
      .then((response) => {
        Vue.$log.debug('created notification successfully', response.data);
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  },

  updateNotification({id, notification}) {
    const url = `${getNotificationsApiUrl()}/notifications/draft/update/${id}`;
    return axios.put(url,
      notification, {
        headers: {
          ...Vue.prototype.$OAuth.buildHttpHeader({
            'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
            'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
            Accept: "application/json",
            "Content-Type": "application/json; charset=UTF-8",
            "adfs": "true"
          }),
        }
      }
    )
      .then((response) => {
        Vue.$log.debug('updated notification successfully', response.data);
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  },

  approveNotification(id) {
    const url = `${getNotificationsApiUrl()}/notifications/draft/approve/${id}`;
    return axios.put(url,{}, {
        headers: {
          ...Vue.prototype.$OAuth.buildHttpHeader({
            'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
            'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
            Accept: "application/json",
            "Content-Type": "application/json; charset=UTF-8",
            "adfs": "true"
          }),
        }
      }
    )
      .then((response) => {
        Vue.$log.debug('approved notification successfully', response.data);
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  },

  deleteNotification(id) {
    const url =  `${getNotificationsApiUrl()}/notifications/draft/delete/${id}`;
    return axios.delete(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs": "true"
        }),
      }
    })
      .then(response => {
        Vue.$log.debug('deleted notification successfully', response.data);
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  },

  deleteAllNotifications() {
    const url =  `${getNotificationsApiUrl()}/notifications/draft/delete/all`;
    return axios.delete(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs":"true"
        }),
      }
    })
      .then(response => {
        Vue.$log.debug('deleted all notifications successfully', response.data);
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  },

  sendNotification({method, requestBody}) {
   const url = `${getNotificationsApiUrl()}/notifications/${method}`;
   return axios.post(url,
     requestBody, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          Content_Type: "application/json; charset=UTF-8",
          "adfs":"true"
        }),
      }
    })
    .then((response) => {
      return response.data;
    })
     .catch(err => {
       throw err;
     });
  }
};
